import React from "react";
import { PrimaryTooltip } from "Components/Shared/PrimaryTooltip";
import { StyledFlex } from "Components/Shared/StyledComponents";
import styled from "styled-components";

type TicketCountIconsProps = {
  ticketsCount: number;
  ticketsAfterDueDateCount: number;
};

const StyledTotalTicketsCount = styled.span`
  margin-left: 2px;
`;

const StyledTicketsCountIcon = styled.div`
  background-color: ${props => props.theme.colors.red};
  border-radius: 20px;
  min-width: 20px;
  color: white;
  height: 20px;
  padding: 0 6px;
`;

export const TicketsAfterDueDateIcon: React.FunctionComponent<{
  count: number;
  styles?: React.CSSProperties;
}> = props => {
  return (
    <PrimaryTooltip
      placement={"top-start"}
      style={props.styles}
      title="Počet tiketů, které jsou po platnosti dva dny a více."
    >
      <StyledTicketsCountIcon>{props.count}</StyledTicketsCountIcon>
    </PrimaryTooltip>
  );
};

export const TicketsCountIcon: React.FunctionComponent<{
  count: number;
}> = props => {
  return (
    <PrimaryTooltip
      placement={"top-start"}
      title="Celkový počet aktuálních tiketů"
    >
      <StyledTotalTicketsCount>({props.count})</StyledTotalTicketsCount>
    </PrimaryTooltip>
  );
};

export const TicketCountIcons: React.FunctionComponent<TicketCountIconsProps> = props => {
  return (
    <StyledFlex>
      <TicketsAfterDueDateIcon count={props.ticketsAfterDueDateCount} />
      <TicketsCountIcon count={props.ticketsCount} />
    </StyledFlex>
  );
};
